<template>
	<div>
		<form-sidebar>
			<v-layout wrap>
				<v-subheader>Recurso: {{ resourceName }}</v-subheader>
			</v-layout>
			<v-layout wrap>
				<v-flex xs12 pb-3>
					<resource-action-list
						:check-all="checkAll"
						:columns="columns"
						:rows="actions"
						:selected-value="selectedValue"
						@all-is-selected="allIsSelected"
						@on-search="onSearchList"
						@row-is-selected="rowIsSelected"
					/>
				</v-flex>
			</v-layout>
			<section class="modal-filter-footer">
				<modal-sidebar-button
					:is-loading="buttonDisabled"
					:on-run-service="loading"
					@accept-button-clicked="submitForm"
					@cancel-button-clicked="closeModal"
				/>
			</section>
		</form-sidebar>
	</div>
</template>

<script>
	import resourceActionList from '@/components/resources/resource-action-list';

	const PAGE_RESOURCE_LIST = 'page-resource';

	function created() {
		this.actionParams.codeProject = this.codeProject;
		this.actionParams.resourceId = this.resourceId;
		this.loadActions();
	}

	function allIsSelected(checked) {
		this.checkAll = checked;
		this.actions = this.selectIsRow(this.actions, this.selectedValue, false, checked);
	}

	function buttonDisabled() {
		return this.every(this.actions, this.selectedValue, true) || this.loading;
	}

	function closeModal() {
		this.goTo(PAGE_RESOURCE_LIST);
	}

	async function loadActions() {
		const params = this.actionParams;
		const headers = this.version;
		try {
			const { data: actions } = await this.$http.get('action-list', { params, headers });
			this.actions = actions.data.map((action) => {
				const newAction = { ...action };
				const keyLanguages = Object.keys(action.languages);
				const firstLanguages = keyLanguages[0];
				newAction[this.selectedValue] = action[this.selectedValue] === 1;
				newAction.name = action.languages.es ? action.languages.es.name
					: action.languages[firstLanguages].name;
				return newAction;
			});
			this.checkAll = this.every(this.actions, this.selectedValue);
		} catch (err) {
			this.showError();
		}
	}

	function onSearchList(value) {
		this.actionParams.search = value;
		this.loadActions();
	}

	function rowIsSelected(row) {
		this.actions = this.selectIsRow(this.actions, this.selectedValue, row);
		this.checkAll = this.every(this.actions, this.selectedValue);
	}

	async function submitForm() {
		const actionsSelected = this.actions.filter(action => action[this.selectedValue]);
		const actions = actionsSelected.map((p) => {
			const newArray = {};
			newArray.id = p.id;
			newArray.flagSelected = p.flagSelected;
			return newArray;
		});
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		this.loading = true;
		try {
			await this.$http.post(`resource/${this.resourceId}/actions`, { actions }, { headers });
			this.showNotification('La barra de acciones ha sido asignada correctamente');
			this.goTo(PAGE_RESOURCE_LIST);
		} finally {
			this.loading = false;
		}
	}

	function data() {
		return {
			actionParams: {
				codeProject: '',
				resourceId: 0,
			},
			actions: [],
			checkAll: false,
			columns: [
				{ id: 1, name: 'Nombre', checked: true, visible: true },
				{ id: 2, name: 'Código', checked: true, visible: true },
				{ id: 3, name: 'Url Web', checked: true, visible: true },
				{ id: 4, name: 'Fragment Móvil', checked: true, visible: true },
			],
			loading: false,
			selectedValue: 'flagSelected',
			version: {
				Accept: `${process.env.ACCEPT_SERVICE_V2}`,
			},
		};
	}

	export default {
		name: 'resource-action-form',
		components: {
			resourceActionList,
		},
		computed: {
			buttonDisabled,
		},
		created,
		data,
		methods: {
			allIsSelected,
			closeModal,
			loadActions,
			onSearchList,
			rowIsSelected,
			submitForm,
		},
		props: {
			codeProject: {
				type: String,
				required: true,
			},
			resourceId: {
				type: [Number, String],
				required: true,
			},
			resourceName: {
				type: String,
				required: true,
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/resources/resource-action-form.vue